import { baseViewWithIdSchema } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const getOmsPriorityFilters = {
  name: "getOmsPriorityFilters" as const,
  input: z.object({}),
  output: z.object({ filters: z.array(baseViewWithIdSchema) }),
};
